import { Icon } from '../../Services/constant/serviceType';

export const RentIcon = ({ size, color }: Icon) => {
  return (
      <>
          <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M16.4917 12.4426C14.775 14.1509 12.3167 14.6759 10.1584 14.0009L6.23337 17.9176C5.95004 18.2092 5.39171 18.3842 4.99171 18.3259L3.17504 18.0759C2.57504 17.9926 2.01671 17.4259 1.92504 16.8259L1.67504 15.0092C1.61671 14.6092 1.80837 14.0509 2.08337 13.7676L6.00004 9.85091C5.33337 7.68425 5.85004 5.22591 7.56671 3.51758C10.025 1.05924 14.0167 1.05924 16.4834 3.51758C18.95 5.97591 18.95 9.98425 16.4917 12.4426Z"
                  stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"
                  strokeLinejoin="round"/>
              <path d="M5.7417 14.5742L7.65837 16.4909" stroke={color} strokeWidth="2" strokeMiterlimit="10"
                    strokeLinecap="round" strokeLinejoin="round"/>
              <path
                  d="M12.0833 9.16602C12.7736 9.16602 13.3333 8.60637 13.3333 7.91602C13.3333 7.22566 12.7736 6.66602 12.0833 6.66602C11.3929 6.66602 10.8333 7.22566 10.8333 7.91602C10.8333 8.60637 11.3929 9.16602 12.0833 9.16602Z"
                  stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>

      </>
  );
};
